// extracted by mini-css-extract-plugin
export var actions = "_kl-d";
export var benefitCard = "_kl-a";
export var benefitIcon = "_kl-b";
export var benefitLabel = "_kl-c";
export var benefits = "_kl-9";
export var bodyText = "_kl-8";
export var closeButton = "_kl-2";
export var content = "_kl-3";
export var eyebrow = "_kl-4";
export var heading = "_kl-5";
export var image = "_kl-f";
export var imagePanel = "_kl-e";
export var modal = "_kl-0";
export var shell = "_kl-1";
export var title = "_kl-6";
export var titleOffer = "_kl-7";